<template>
  <div class="ONE-TIME-CODE">
    <div class="text-left">
      <a class="link-black" @click="back">
        <vk-icon name="chevronleft" class="c-depot"/>
        Back
      </a>
    </div>
    <one-time-code-form :redirectTo="redirectTo" :defaultEmail="email"/>
    Already have an account?
    <router-link
        :to="{
          name: 'login',
          query: {
            email,
            redirectTo
          }
        }"
        class="link">
      Sign in with password.
    </router-link>
  </div>
</template>

<script>
import OneTimeCodeForm from '@/components/OneTimeCodeForm';

export default {
  name: 'one-time-code',
  components: {
    OneTimeCodeForm,
  },
  props: {
    redirectTo: {
      type: [Object, String],
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
  },
  methods: {
    back () {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .ONE-TIME-CODE {
    text-align: center;
    @include margin(6 auto);
  }
</style>
